import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "error"]
    static values = {
        url: String,
        id: String
    }

    connect() {
        this.check = this.debounce(this.check.bind(this), 300)
    }

    check() {
        const cardNumber = this.inputTarget.value.trim()

        if (cardNumber.length === 0) {
            this.clearError()
            return
        }

        // Build URL with params
        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.append('card_number', cardNumber)
        if (this.idValue) {
            url.searchParams.append('id', this.idValue)
        }

        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (!data.available) {
                    this.showError(data.message)
                } else {
                    this.clearError()
                }
            })
            .catch(error => {
                console.error("Validation error:", error)
            })
    }

    showError(message) {
        this.inputTarget.classList.add("border-red-300", "focus:border-red-500", "focus:ring-red-500")
        this.inputTarget.classList.remove("border-border-default", "focus:border-brand", "focus:ring-brand/20")

        this.errorTarget.textContent = message
        this.errorTarget.classList.remove("hidden")
    }

    clearError() {
        this.inputTarget.classList.remove("border-red-300", "focus:border-red-500", "focus:ring-red-500")
        this.inputTarget.classList.add("border-border-default", "focus:border-brand", "focus:ring-brand/20")

        this.errorTarget.textContent = ""
        this.errorTarget.classList.add("hidden")
    }

    debounce(func, wait) {
        let timeout
        return function (...args) {
            clearTimeout(timeout)
            timeout = setTimeout(() => func.apply(this, args), wait)
        }
    }
}
